export default (code, template) => {
  let tempOrigin = {};
  return tempOrigin.install = (Vue, options) => {
    const MessageTipInstance = Vue.extend(template)
    let currentMsg = new MessageTipInstance()
    Vue.component(code, template)
    Vue['$' + code] = currentMsg
  }
}
